import { Box, Button, Container, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { RiCheckboxCircleFill, RiErrorWarningFill } from 'react-icons/ri'
import { Link } from 'react-router-dom'

const PaymentFail = () => {
  return (
    <Container h='90vh' p='16'>
        <VStack justifyContent={'center'} h='full' spacing={'4'}>
        <RiErrorWarningFill size={'5rem'}/>
        <Heading my='8' textAlign={'center'} children='The Payment was not successful' />
            <Link my='8' to="/subscribe">
                <Button variant='outline'>
                    Try again ?
                </Button>
            </Link>
            <Link my='8' to="/">
                <Button colorScheme={'yellow'} variant='outline'>
                    Go to Home
                </Button>
            </Link>
        </VStack>
    </Container>
  )
}

export default PaymentFail